
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/van/fiat-ducato",
      function () {
        return require("private-next-pages/rims/van/fiat-ducato.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/van/fiat-ducato"])
      });
    }
  